export default __webpack_public_path__ + "static/media/persons.5f43e59b.svg";